/**
 * Resolve whether this shape filled a coach blocker/validation gap.
 * Prefers shape.meta.doneKey; falls back to userProgress.doneFills.
 *
 * @returns {{ doneKey: string, kind: 'blocker'|'validation', source: 'meta'|'doneFills' }|null}
 */
export function resolveBlockerDoneFill(shape, {
  activityId = '',
  doneFills = null,
} = {}) {
  if (!shape) return null;
  const metaKey = String(shape.meta?.doneKey || '').trim();
  if (metaKey) {
    return {
      doneKey: metaKey,
      kind: 'blocker',
      source: 'meta',
    };
  }

  const metaPartialKey = String(shape.meta?.partialKey || '').trim();
  if (metaPartialKey) {
    return {
      doneKey: metaPartialKey,
      kind: 'partial',
      source: 'meta',
    };
  }

  const shapeId = String(shape.id || '').trim();
  const aid = String(activityId || shape.meta?.activityId || '').trim();
  const fills = Array.isArray(doneFills) ? doneFills : [];
  const match = fills.find((entry) => {
    const entryShapeId = String(entry?.shapeId || '').trim();
    const entryActivityId = String(entry?.activityId || '').trim();
    if (shapeId && entryShapeId && entryShapeId === shapeId) return true;
    if (aid && entryActivityId && entryActivityId === aid) return true;
    return false;
  });
  if (!match) return null;
  const doneKey = String(match.doneKey || '').trim();
  if (!doneKey) return null;
  return {
    doneKey,
    kind: match.kind === 'validation' ? 'validation' : 'blocker',
    source: 'doneFills',
  };
}
